<template>
  <v-btn v-bind="$attrs" @click="download" color="success" :loading="loading">
    <v-icon>fas fa-file-excel</v-icon>
  </v-btn>
</template>

<script>
import {downloadBlobFile} from "@/utils/pureFunctions";

export default {
  name: 'DownloadExcelDebtor',
  props: {
    filter: {
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async download() {
      this.loading = true
      try {
        const {data} = await this.$http.get('admin/credits/debtors', {
          params: {...this.filter, excel: true},
          responseType: 'blob'
        })
        downloadBlobFile(data)
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.loading = false
      }
    }
  }
}
</script>